import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import ListLogAnalysisTable from '../Components/ListLogAnalysisTable';

const ListLogAnalysisPage = () => {
    return (
        <Container maxWidth={false} sx={{ maxWidth: '90%' }}>
            <Box my={4}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Анализ список-логи
                </Typography>
                <ListLogAnalysisTable />
            </Box>
        </Container>
    );
};

export default ListLogAnalysisPage;
